import { useState } from 'react';
import { QAItem } from '../components/productQA-item';

const useBreathe = () => {
  const [breathing, setBreathing] = useState<number[]>([]);

  const addBreathing = (values: { from: number; to: QAItem }[]) => {
    const ids = values.map(vo => vo.to.id);
    setBreathing([...breathing, ...ids]);
    setTimeout(() => {
      setBreathing(breathing.filter((b) => !ids.includes(b)));
    }, 5000)
  }

  return { breathing, addBreathing }
}

export default useBreathe;
